import apiService from "../common/commonApi";

export const leaveDetail = {};

leaveDetail.list = async (param) => {
    return apiService.Get("getLeaveDetail", param);
};
